<template>
	<div
		ref="mortgagePartsTable"
		class="grid"
		:class="{
			'grid-cols-[32px_110px_280px_1fr_1fr_80px_64px]': showMortgageParts,
		}"
	>
		<div class="col-span-full border-b p-2">
			<h3 class="sticky left-2 w-fit">Leningdelen</h3>
		</div>
		<template v-if="showMortgageParts">
			<div
				class="grid grid-cols-subgrid col-span-full [&>*]:not-first:border-s [&>*]:border-b text-sm font-semibold [&>span]:p-2"
			>
				<div />
				<span>Hoogte</span>
				<span>Hypotheekvorm</span>
				<span>Looptijd&nbsp;(mnd.)</span>
				<span>Rentevast&nbsp;(mnd.)</span>
				<span>Rente</span>
				<div class="sticky right-0 bg-white z-20 border-l" />
			</div>
			<ul class="grid grid-cols-subgrid col-span-full">
				<template
					v-for="(leningdeel, idx) in mortgageParts"
					:key="leningdeel.id"
				>
					<MortgagePartRow
						v-if="mortgageParts"
						v-model="mortgageParts[idx]"
						:available-mortgage-parts="availableMortgageParts"
						:card-width="`${width}px`"
						@delete="mortgageParts.splice(idx, 1)"
					/>
				</template>
				<MortgagePartTotals :totals />
			</ul>
		</template>
		<div v-else class="col-span-full border-b bg-gray-100 text-center p-1">
			<span class="text-sm text-gray-600">Geen leningdelen gevonden</span>
		</div>
		<div class="col-span-full">
			<AppButton
				v-if="userStore?.user?.role === 'intermediary'"
				variant="ghost"
				icon="add"
				class="sticky left-1 text-gray-600 my-1"
				@click="emit('add-leningdeel')"
			>
				Nieuw leningdeel toevoegen
			</AppButton>
		</div>
	</div>
</template>

<script setup lang="ts">
import { useUserStore } from "@/store/useUserStore";
import type {
	ExistingMortgagePart,
	MortgagePart,
	LeningdelenTotaaldeel,
} from "@loanlink-nl/model-app";
import { useElementSize } from "@vueuse/core";
import { computed, useTemplateRef } from "vue";

const mortgageParts = defineModel<MortgagePart[]>();

const emit = defineEmits<{
	(e: "add-leningdeel"): void;
}>();

defineProps<{
	totals?: LeningdelenTotaaldeel;
	availableMortgageParts: ExistingMortgagePart[];
}>();

const userStore = useUserStore();
const mortgagePartsTable = useTemplateRef("mortgagePartsTable");
const { width } = useElementSize(mortgagePartsTable);

const showMortgageParts = computed(
	() => mortgageParts.value && mortgageParts.value.length > 0,
);
</script>
